export default defineNuxtRouteMiddleware(async (to, _) => {
    const map = {
        index: '/events'
    }

    if (map[to.name]) {
        return navigateTo(map[to.name], {
            replace: false,
            redirectCode: 302
        })
    }

    return
})
